import { render, staticRenderFns } from "./MemosModal.vue?vue&type=template&id=0863e5f6&"
import script from "./MemosModal.vue?vue&type=script&lang=js&"
export * from "./MemosModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports